// extracted by mini-css-extract-plugin
export default {"Loader":"loader_Loader__o1HBF","LoaderSmall":"loader_LoaderSmall__R26yE","spin":"loader_spin__1-Dpg","LoaderWrapper":"loader_LoaderWrapper__hVKeg"};